var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.363,
    height: 26.329,
    viewBox: "0 0 32.363 26.329",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M29.675,5.8H29.4a3,3,0,0,0-2.683-2.631A3,3,0,0,0,23.739.5H4.636A4.642,4.642,0,0,0,0,5.136V18.53a3,3,0,0,0,2.7,2.98,3,3,0,0,0,2.927,2.672,2.683,2.683,0,0,0,2.686,2.647H29.675a2.69,2.69,0,0,0,2.687-2.687V8.491A2.69,2.69,0,0,0,29.675,5.8ZM31.1,8.491v10.35l-2.75-2.077a2.11,2.11,0,0,0-2.528-.022l-3.478,2.534-6.633-6.838a2.119,2.119,0,0,0-2.927-.114l-5.889,5.2V8.491A1.424,1.424,0,0,1,8.316,7.069H29.675A1.424,1.424,0,0,1,31.1,8.491Zm0,15.65a1.424,1.424,0,0,1-1.423,1.423H8.316a1.423,1.423,0,0,1-1.423-1.423V19.205l6.725-5.933a.856.856,0,0,1,1.183.046L17.8,16.4h0l5.958,6.143a.632.632,0,1,0,.907-.88l-1.43-1.475,3.334-2.429a.853.853,0,0,1,1.022.009L31.1,20.425ZM3.95,21.19V6.265a1.821,1.821,0,0,1,.01-.188A1.844,1.844,0,0,1,5.792,4.423h7.732a.632.632,0,1,0,0-1.264H5.792A3.11,3.11,0,0,0,2.686,6.265V20.233a1.733,1.733,0,0,1-1.422-1.7V5.136A3.376,3.376,0,0,1,4.636,1.764h19.1a1.732,1.732,0,0,1,1.7,1.4H18.581a.632.632,0,0,0,0,1.264h7.845A1.733,1.733,0,0,1,28.119,5.8H8.316A2.69,2.69,0,0,0,5.63,8.492V18.92h0v4A1.731,1.731,0,0,1,3.95,21.19Zm0,0",
    transform: "translate(0.001 -0.5)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M348.424,145.117a2.705,2.705,0,1,0,2.7,2.7A2.708,2.708,0,0,0,348.424,145.117Zm0,4.146a1.441,1.441,0,1,1,1.441-1.441A1.443,1.443,0,0,1,348.424,149.263Zm0,0",
    transform: "translate(-326.336 -135.976)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M244.009,43.447a.652.652,0,0,0,.058.109.625.625,0,0,0,.079.1.66.66,0,0,0,.1.079.642.642,0,0,0,.109.058.626.626,0,0,0,.241.048.636.636,0,0,0,.124-.012.64.64,0,0,0,.227-.094.677.677,0,0,0,.1-.079.629.629,0,0,0,.079-.1.648.648,0,0,0,.058-.109.667.667,0,0,0,.036-.118.646.646,0,0,0,.012-.124.638.638,0,0,0-.106-.351.617.617,0,0,0-.079-.1.628.628,0,0,0-.1-.079.64.64,0,0,0-.227-.094.621.621,0,0,0-.247,0,.629.629,0,0,0-.118.036.643.643,0,0,0-.109.058.622.622,0,0,0-.175.175.641.641,0,0,0-.107.351.639.639,0,0,0,.013.124A.659.659,0,0,0,244.009,43.447Zm0,0",
    transform: "translate(-231.01 -39.914)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMedia);
export default __webpack_public_path__ + "static/media/icon-media.83fa4fcf9e6f0ed25d87973803a5b0c6.svg";
export { ForwardRef as ReactComponent };